module.exports = __webpack_public_path__ + "static/media/favicon-generalitat.af3baf2a.ico";